import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import { WithTooltip } from 'basic-components';
import { Exit } from 'basic-components/icons';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';

const Actions = ({ items, index }) => {
  const getUrl = useCallback(index => DashboardLinkFactory.dataScience.pipeline({ groupName: items[index]?.group, pipelineName: items[index]?.name, version: items[index]?.version }), [items])
  return (
    <WithTooltip
        data-place="top"
        key="openPipeline"
        short
        text="Open pipeline"
    >
      <a
          href={getUrl(index)}
          rel="noreferrer"
          target="_blank"
      >
        <Exit
            color="blue-bright"
            height={16}
            width={16}
        />
      </a>
    </WithTooltip>
  )
}

Actions.propTypes = {
  index: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
}

export default memo(Actions)
